export enum MetStatuses {
    AD_HOC = 'AD_HOC',
    REPEATABLE = 'REPEATABLE',
    DEFINED = 'DEFINED',
    OPTIMIZED = 'OPTIMIZED',
    INNOVATIVE = 'INNOVATIVE',
    EXEMPTED = 'EXEMPTED',
    NOT_APPLICABLE = 'NOT_APPLICABLE'
}
